import * as React from "react";
import { ComponentBase } from "../ComponentBase";
import { Text, TextProps } from "../Text/Text";
import "./LoyaltyQuestButton.css";
import {
  getIsLoadingLoyaltyQuestToken,
  getLoyaltyQuestToken,
} from "../../reducers/loyalty/methods";
import get from "lodash/get";

export interface LoyaltyQuestButtonComponentProps extends TextProps {
  classNames: string;
  isLoading: ReturnType<typeof getIsLoadingLoyaltyQuestToken>;
  loyaltyQuestToken: ReturnType<typeof getLoyaltyQuestToken>;
  clientId: string;
  editStatus: "success" | "error" | "loading";
}

/**
 * LQButton component that wraps the Text component and handles
 * LoyaltyQuest-specific functionality when actionURL contains
 * loyaltyquest_jwt and loyaltyquest_client_id merge variables.
 */
export class LoyaltyQuestButton extends ComponentBase<LoyaltyQuestButtonComponentProps> {
  constructor(props: LoyaltyQuestButtonComponentProps) {
    super(props);
  }

  getEditContent = () => {
    const { isEditing, content, action, loyaltyQuestToken } = this.props;
    const actionURL = get(action, "args.url", "");
    const containsLoyaltyQuestVariables =
      this.hasLoyaltyQuestVariables(actionURL);

    // Show content if editing, loading if unedited with LQ vars, content otherwise
    if (isEditing) {
      return content;
    }

    if (containsLoyaltyQuestVariables && !loyaltyQuestToken) {
      return "Loading...";
    }

    return content;
  };

  render() {
    const {
      content,
      action,
      loyaltyQuestToken,
      clientId,
      classNames,
      isEditing,
      ...restProps
    } = this.props;

    return (
      <Text
        {...restProps}
        content={this.getEditContent()}
        classNames={`LoyaltyQuestButton-text ${classNames || ""}`}
        action={action}
        isEditing={isEditing}
      />
    );
  }

  /**
   * Checks if the actionURL contains LoyaltyQuest merge variables
   */
  private hasLoyaltyQuestVariables = (url: string): boolean => {
    return (
      url.includes("{{loyaltyquest_jwt}}") &&
      url.includes("{{loyaltyquest_client_id}}")
    );
  };
}
